export const CYBER_THEMES = [
  {
    id: "6da50d2b-ed99-467d-9960-f9561b9035fc",
    title: "Cyber Threat Landscape",
    parent: null,
    hasData: true,
    order: 10,
  },
  // {
  //   id: "64fb071c-32ed-4c6e-bc14-b06483e4f349",
  //   title: "Glossary",
  //   parent: null,
  //   hasData: true,
  //   order: 20,
  // },
  {
    id: "7cb195c3-0ea9-48ea-8920-45ae510bb578",
    title: "Methodology",
    parent: null,
    hasData: true,
    order: 30,
  },

  { id: "4", title: "Nation States", parent: null, order: 40 },
  {
    id: "4e8d8427-a491-40eb-9d22-69e61f632f2b",
    title: "Nation States Overview",
    parent: "4",
    order: 41,
  },
  {
    id: "486f117f-e402-4589-a092-9e7bc8a14556",
    title: "Nation States Scenarios",
    parent: "4",
    order: 42,
  },

  { id: "7", title: "Cybercrime", parent: null, order: 50 },
  {
    id: "28885aff-7e0b-4b77-a31a-0a73f6f1c7ed",
    title: "Cybercrime Overview",
    parent: "7",
    order: 51,
  },
  {
    id: "d49d2c34-e399-4788-b899-0a988a840453",
    title: "Cybercrime Scenarios",
    parent: "7",
    order: 52,
  },

  { id: "10", title: "Cyber Activism", parent: null, order: 60 },
  {
    id: "e5693208-f671-4202-8133-812333c1c8a4",
    title: "Activism Overview",
    parent: "10",
    order: 61,
  },
  {
    id: "d3e3eac6-2be1-4adb-91af-daa38c18b21e",
    title: "Activism Scenarios",
    parent: "10",
    order: 62,
  },

  { id: "13", title: "Cyber Threat Mitigation", parent: null, order: 70 },
  {
    id: "96bf155e-6294-4e8a-83fc-2acee362e820",
    title: "Cyber Threat Mitigation",
    parent: "13",
    order: 70,
  },
  {
    id: "684a97fe-0582-4ecf-bc69-be5bdc39d8d4",
    title: "Malware Distribution",
    parent: "13",
    order: 71,
  },
  {
    id: "e152c35d-2576-4de1-b280-dbfcaab961e6",
    title: "General Malware",
    parent: "13",
    order: 72,
  },
  {
    id: "afd02820-550b-4048-bdf1-2d48783a3cfc",
    title: "Ransomware",
    parent: "13",
    order: 73,
  },
  {
    id: "7020c876-f0c5-490f-938c-9b995701f7c4",
    title: "Spyware",
    parent: "13",
    order: 74,
  },
  {
    id: "5937d7aa-6a1a-40f6-9a1b-a1d2593708df",
    title: "Attacks Targetting Websites",
    parent: "13",
    order: 75,
  },
  {
    id: "580887b2-2f5d-47fa-9531-059610c7ca6c",
    title: "DDoS Attacks",
    parent: "13",
    order: 76,
  },
  {
    id: "7e409cf8-3062-4358-8355-f842afd305ad",
    title: "Point of Sale Malware",
    parent: "13",
    order: 77,
  },
  {
    id: "663fc684-4e08-4935-8c54-4b30f5610d15",
    title: "Threats to Cloud Services",
    parent: "13",
    order: 78,
  },
  {
    id: "28eb18ba-99b7-4e43-8654-2d79195a56e4",
    title: "Brute Force Attacks",
    parent: "13",
    order: 79,
  },
  {
    id: "d04a27f7-7daa-4d82-93e0-8c0db8832312",
    title: "Third Party Network Access",
    parent: "13",
    order: 80,
  },
  {
    id: "208005f0-1c85-4337-9021-839c3c476f07",
    title: "Physical Threats to IT Systems",
    parent: "13",
    order: 81,
  },
  {
    id: "7584780e-4274-4896-be6b-9de34cd261a6",
    title: "Signals Interference",
    parent: "13",
    order: 82,
  },
  {
    id: "9073d711-954e-4965-9492-8467346d0072",
    title: "Remote Workers",
    parent: "13",
    order: 83,
  },
  {
    id: "90f9ab3e-6869-4b71-aef2-708919ce68e5",
    title: "Home Workers",
    parent: "13",
    order: 84,
  },
  {
    id: "794bc3e9-50d2-4312-952b-fe5b3b5de626",
    title: "Malicious Insider Threats",
    parent: "13",
    order: 85,
  },
  {
    id: "17078a10-f3ba-4f6c-857e-4aa341e7daf9",
    title: "Threats to VPNs and 2FA",
    parent: "13",
    order: 86,
  },

  { id: "30", title: "Attack Profiles", parent: null, order: 90 },
  {
    id: "1de49174-2325-4090-85ac-2afd84054e1f",
    title: "Attack Profiles",
    parent: "30",
    order: 91,
  },
  // {
  //   id: "84ed60ef-b0d0-4f8d-9702-845ddfb6376d",
  //   title: "Banking Trojans",
  //   parent: "30",
  //   order: 92,
  // },
  {
    id: "90579e90-880f-4efd-931e-a640ea494333",
    title: "Business Email Compromise",
    parent: "30",
    order: 93,
  },
  {
    id: "5d85b100-7e00-45fb-aed7-e75d70953364",
    title: "Ransomware",
    parent: "30",
    order: 94,
  },
  {
    id: "f2f3bd4b-ccaf-49c7-ae7d-7a9514915a77",
    title: "SolarWinds",
    parent: "30",
    order: 95,
  },

  { id: "36", title: "Threat Actor Profiles", parent: null, order: 100 },
  {
    id: "2825a9a6-a392-4a6a-8752-8b6dc53355d3",
    title: "Threat Actor Profiles",
    parent: "36",
    order: 101,
  },
  {
    id: "8a9d5ccb-20d8-4f0a-8ba0-9a6367aa1d94",
    title: "APT29",
    parent: "36",
    order: 102,
  },
  {
    id: "da499623-4582-4ebd-a32d-0afb862faf07",
    title: "APT32",
    parent: "36",
    order: 103,
  },
  {
    id: "7e25c2c4-db57-4ae0-89e8-44be7dc9fc77",
    title: "APT33",
    parent: "36",
    order: 104,
  },
  {
    id: "50f83344-80de-4dc1-a476-652e445e5b47",
    title: "APT34",
    parent: "36",
    order: 105,
  },
  // {
  //   id: "bf4af0ec-732d-42fd-9434-8098e7460c0c",
  //   title: "APT35 and APT42",
  //   parent: "36",
  //   order: 106,
  // },
  {
    id: "4a17345a-6669-4d0b-8748-83484a8141e3",
    title: "Cobalt",
    parent: "36",
    order: 107,
  },
  {
    id: "38238858-09c8-47b8-a26c-5531e302891c",
    title: "DarkHotel",
    parent: "36",
    order: 108,
  },
  {
    id: "a4cd3938-471a-41c9-a6b9-4eab5cdf6912",
    title: "DarkSide",
    parent: "36",
    order: 109,
  },
  {
    id: "6a2aec89-5315-4a5b-a7ec-cced3dbcb4f1",
    title: "Egregor",
    parent: "36",
    order: 110,
  },
  {
    id: "244e2e34-9139-41c2-9c81-ad5259edf8f5",
    title: "Equation Group",
    parent: "36",
    order: 111,
  },
  {
    id: "523d1ee3-aa56-4916-8869-8df1f2d392b2",
    title: "Evil Corp",
    parent: "36",
    order: 112,
  },
  {
    id: "49827a59-f8e8-44bc-a9a0-1b955fa6e25d",
    title: "Insiders",
    parent: "36",
    order: 113,
  },
  {
    id: "f28bfa97-490d-4610-8c57-0693d0642b52",
    title: "Maze Team",
    parent: "36",
    order: 114,
  },
  {
    id: "2d42be4b-a17f-493b-8788-8c846f49f6ac",
    title: "REvil",
    parent: "36",
    order: 115,
  },
  {
    id: "4ec6f536-eb21-44c3-9f3a-bb6ff63d1c01",
    title: "Silence",
    parent: "36",
    order: 116,
  },
  {
    id: "2f0b463f-64c7-4450-b739-c8d108b6e5ed",
    title: "StrongPity",
    parent: "36",
    order: 117,
  },
  {
    id: "5aca959e-bd5f-433d-a467-81cbb322dd83",
    title: "Trickbot",
    parent: "36",
    order: 118,
  },
  {
    id: "782fb20f-ce68-4eb3-b871-31a2f40223bb",
    title: "Turla",
    parent: "36",
    order: 119,
  },
  {
    id: "e5d53557-b1c1-4047-b832-02803abbefe4",
    title: "Unit 8200",
    parent: "36",
    order: 120,
  },

  { id: "57", title: "Sector Profiles", parent: null, order: 130 },
  {
    id: "9cc977c4-d142-4be6-b3ce-bcfed8533cfd",
    title: "Sector Profiles",
    parent: "57",
    order: 131,
  },
  {
    id: "28978715-a6fc-45e8-b4dd-d7dcb94a4793",
    title: "Automotives",
    parent: "57",
    order: 132,
  },
  {
    id: "26b566a5-cfe8-42e7-97ea-789a21f6b2b4",
    title: "Aviation and defence",
    parent: "57",
    order: 133,
  },
  {
    id: "e5593a05-d925-418c-bb97-d324c85cec41",
    title: "Commercial Aviation",
    parent: "57",
    order: 134,
  },
  {
    id: "b0b8b9de-cb2d-437a-8a46-05c55cc62bad",
    title: "Building and Construction",
    parent: "57",
    order: 135,
  },
  {
    id: "0f1ba44e-7f0c-4bcc-90a6-276843795c3f",
    title: "Computer Gaming",
    parent: "57",
    order: 136,
  },
  {
    id: "7e79068e-7a1c-4e14-9788-1659669494db",
    title: "Education and Training",
    parent: "57",
    order: 137,
  },
  {
    id: "29ed491e-5edd-4963-9674-c58839678f14",
    title: "Energy and Utilities",
    parent: "57",
    order: 138,
  },
  {
    id: "f4e039e2-b8fc-4b40-b963-dd376b413d15",
    title: "Energy Infrastructure",
    parent: "57",
    order: 139,
  },
  {
    id: "79f36532-c824-455e-b909-d60f5a0ebca5",
    title: "Nuclear Energy",
    parent: "57",
    order: 140,
  },
  {
    id: "5881c81b-1845-400a-97c7-89a40e49d052",
    title: "Oil and Gas",
    parent: "57",
    order: 141,
  },
  {
    id: "fd0e926d-03c1-4758-899a-b09229a677af",
    title: "Renewables",
    parent: "57",
    order: 142,
  },
  {
    id: "0d36b509-1d28-459d-9ba6-b4bd69f4b6da",
    title: "Water and Waste Management",
    parent: "57",
    order: 143,
  },
  {
    id: "1dbcc147-97df-4a07-a38b-2da47391f85c",
    title: "Finance and Insurance",
    parent: "57",
    order: 144,
  },
  {
    id: "f9e6a47e-efbf-42a8-9368-5e603668766e",
    title: "Central Banks and Sovereign Wealth Funds",
    parent: "57",
    order: 145,
  },
  {
    id: "232fe395-48c2-4d9d-9dff-94e6b0583555",
    title: "Investment Banking",
    parent: "57",
    order: 146,
  },
  {
    id: "e9f9f989-30b5-41ca-981c-f79b4d0ae943",
    title: "Retail Banking",
    parent: "57",
    order: 147,
  },
  {
    id: "677f56f4-cd79-407c-8bfd-5f36a5a6f27c",
    title: "FMCG",
    parent: "57",
    order: 148,
  },
  {
    id: "9208a699-d1ef-44b3-96ca-642b303f393c",
    title: "Government and Administration",
    parent: "57",
    order: 149,
  },
  {
    id: "c9450cbf-72ff-477c-a65a-93c4ad73df45",
    title: "Central Governments and Political Parties",
    parent: "57",
    order: 150,
  },
  {
    id: "282f7e2e-cade-4541-9d83-74c72df20818",
    title: "Hotels, Sport and Entertainment",
    parent: "57",
    order: 151,
  },
  {
    id: "04773a55-9c2d-40c6-b3ea-92e0bd34b1ad",
    title: "International Organizations",
    parent: "57",
    order: 152,
  },
  {
    id: "22de7b4c-5d5f-4a04-9930-b20337a7eb66",
    title: "IT and Telecoms",
    parent: "57",
    order: 153,
  },
  {
    id: "b648e9c9-0a23-4246-8463-e93835f687ef",
    title: "Data Processing and Hosting",
    parent: "57",
    order: 154,
  },
  {
    id: "62688dcd-5bdc-4e51-bf57-db076b1d77a6",
    title: "Legal Services",
    parent: "57",
    order: 155,
  },
  {
    id: "07d5c033-b054-4b82-a30f-2118bddd6b51",
    title: "Logistics and Transport",
    parent: "57",
    order: 156,
  },
  {
    id: "9fa92746-268d-4e0f-8be5-032b4d2369ee",
    title: "Manufacturing",
    parent: "57",
    order: 157,
  },
  {
    id: "55ee07e7-ab6a-408b-a159-b098ae64775e",
    title: "Maritime",
    parent: "57",
    order: 158,
  },
  {
    id: "bfaca9d8-e68e-47e9-aa2d-1d0b74a4d169",
    title: "Shipping",
    parent: "57",
    order: 159,
  },
  {
    id: "8000b006-a5ae-4c97-945e-2a4d43e597b6",
    title: "Media and Publishing",
    parent: "57",
    order: 160,
  },
  {
    id: "a13a88e7-1916-4005-ba4b-e862b6c0b8b8",
    title: "Mining",
    parent: "57",
    order: 161,
  },
  {
    id: "0b9acc5a-8417-412e-a227-7f0e82d0397c",
    title: "NGOs",
    parent: "57",
    order: 162,
  },
  {
    id: "49033b94-d6dd-4f18-a135-915eea657e90",
    title: "Pharmaceuticals and Health",
    parent: "57",
    order: 163,
  },
  {
    id: "6050ae25-9a0f-4cdc-b72b-9fae6be35e10",
    title: "Retail",
    parent: "57",
    order: 164,
  },

  { id: "92", title: "Technology Focus", parent: null, order: 170 },
  {
    id: "be3db29b-ea67-469a-adee-630ca4f0e7f8",
    title: "Technology Focus",
    parent: "92",
    order: 171,
  },
  {
    id: "3f71169d-b03a-4c69-81a4-973218d7658a",
    title: "5G Mobile Telecoms",
    parent: "92",
    order: 172,
  },
  {
    id: "cdab001b-7ba7-4b52-9fd9-7a33e00be657",
    title: "Artificial Intelligence",
    parent: "92",
    order: 173,
  },
  {
    id: "5c312b2d-1347-4fa9-b376-176cda7a42a9",
    title: "Biometrics",
    parent: "92",
    order: 174,
  },
  {
    id: "486ae783-7e2f-488f-bbc6-ea0dc435c76a",
    title: "Cloud Services",
    parent: "92",
    order: 175,
  },
  {
    id: "6beea20c-6503-42e7-a254-0d02635ce685",
    title: "Deepfakes",
    parent: "92",
    order: 176,
  },
  {
    id: "db17a6f3-e89a-431b-b1e6-fe2239900f5a",
    title: "Disinformation",
    parent: "92",
    order: 177,
  },
  {
    id: "641994c3-2df9-436c-af5a-f745e90c7a9e",
    title: "Encryption Services",
    parent: "92",
    order: 178,
  },
  {
    id: "3a9440c4-3e97-4453-be71-d38e4175e859",
    title: "Quantum Computing",
    parent: "92",
    order: 179,
  },
  {
    id: "785c592a-b329-46a8-9970-958ef0247813",
    title: "Tokenization",
    parent: "92",
    order: 180,
  },
];
